import React from "react";
import { Divider, Flex, Select } from "@theorgchartdev/storybook";
import { DataSourceSetupComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/DataSourceSetupComposite";
import { appstr } from "@coreapp/utils/appstr";

export const SAPRFCSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const kSAPOptions = [
    { value: 0, label: appstr("sapoption1") },
    { value: 1, label: appstr("sapoption2") },
    { value: 2, label: appstr("sapoption3") }
  ];
  const BuildSAPOptions = () => {
    let options = [];
    let headers = kSAPOptions;

    for (let header of headers) {
      let option = {
        value: header.value,
        label: header.label,
        clickHandler: e => HandleFieldSelect(e)
      };
      options.push(option);
    }
    return options;
  };
  const HandleFieldSelect = option => {
    onChange({ ...config, SAPOption: option.value });
  };

  return (
    <Flex direction={"column"} gap={"12px"} width={"100%"}>
      <DataSourceSetupComposite
        config={config}
        onChange={onChange}
        index={index}
        showInputControls
        showConfiguration={importType !== "import"}
        showLoadHeaders={importType !== "import"}
        importType={importType}
        showAuth={false}
      />
      <Divider />
      <Flex justifyContent={"space-between"} gap={"8px"}>
        <Select
          listWidth={"large"}
          placeholder={"Select option..."}
          selectSize={"medium"}
          inputOnly={false}
          label={appstr("SAP OrgUnit Chart Options")}
          options={BuildSAPOptions()}
          value={config["SAPOption"]}
        />
      </Flex>
    </Flex>
  );
};
